import CustomKendoWindow from "./CustomKendoWindow";
import widgetTemplate from '../../templates/widgetTemplate.html';
export default class BroadcastWidgetWindow{

    constructor(){
        this.testerIdentifier = "broadcastTools";
        this.unlockTestersDialog = null;
        //@TODO: We can move attendeesInCall to Broadcast.js class to keep UI and functionality separate.
        this.attendeesInCall = new Set();
    }

    createBroadcastWidget(proctorObj, testerHandStatuses){
        this.proctorObj = proctorObj;
        this.windowDiv = $k('<div>').attr('id', 'broadcastWindow');
        this.testerMuteStatuses = new Map();
        this.isProctorMuted = false;
        this.broadcastChatDiv = $k('<div>').attr('id', 'broadcastChatWindow');
        let helpTextDiv = this.addBroadcastHelpText();

        // add widget to body
        $('body').append(this.windowDiv);

        this.windowDiv.append(this.addGroupAudioWindow(),helpTextDiv,this.broadcastChatDiv,this.groupAudioCallDiv);

        //hide end button when adding tools tab and set text to "End Call"
        this.hideEndButton();
        this.setEndCallBtn();
        this.createBroadcastKendoWindow(this.windowDiv);
        this.buildAudioCallView(this.proctorObj.idAndNameMap, testerHandStatuses);
        this.preventDblClickAndRightClick();
        this.center();
        $(window).off('resize',this.handleWindowResize.bind(this)).on('resize',this.handleWindowResize.bind(this));
        this.createVariables();
        this.addTooltips();
        this.windowDiv.addClass('rtp-loading');
		this.windowDiv.append('<i class="fa-solid fa-spinner fa-spin rtp-loading-icon"></i>');
        this.createUnlockTestersDialog();
    }

    showUnlockTestersDialog() {
        const baseZ = parseInt(this.windowDiv?.closest("[role='dialog']").css("z-index"), 10) || 10005;
        this.unlockTestersDialog?.css("z-index", baseZ + 10).removeClass('!k-display-none');
    }

    hideUnlockTestersDialog() {
        this.unlockTestersDialog?.addClass('!k-display-none');
    }

    createUnlockTestersDialog() {
        const dialogHTML = _.template($(widgetTemplate).filter("#unlockTestersDialogView").html());
        $('body').append(dialogHTML());

        const keys = [];
        const dontProceedBtn = $(`#dontProceedButton`);
        const proceedBtn = $(`#proceedButton`);

        dontProceedBtn.off('click').on('click', this.handleDoNotProceedUnlockScreen.bind(this, keys));
        proceedBtn.off('click').on('click', this.handleProceedUnlockScreen.bind(this));

        this.unlockTestersDialog = $('#unlockTestersDialogId').length ? $('#unlockTestersDialogId') : null;
    }

    handleProceedUnlockScreen() {
        if(this.attendeesInCall.size > 0) {
            this.proctorObj?.unlockAllTesters(this.attendeesInCall);
        }
        this.hideUnlockTestersDialog();
    }

    handleDoNotProceedUnlockScreen() {
        //There may be additional logic added here in the future, but for now, simply close the dialog.
        this.hideUnlockTestersDialog();
    }

    createBroadcastKendoWindow(){
        var that = this;
		this.broadcastKendoWindow = this.windowDiv.kendoWindow({
			width: "265px",
			height: "400px",
			minWidth: "265px",
			minHeight:"400px",
			actions: [ "Minimize", "Close"],
			title: rtp_i18next.t('proctorWidget:broadcastWidgetTitle'),
			minimize: function(event) {
                that.setMinimizedWindowPosition(event.sender.wrapper);
                $k(that.broadcastKendoWindow.wrapper.find('button[aria-label="window-restore"]')).kendoTooltip({content: rtp_i18next.t("generalWords:maximize")});
			},
			restore: function (event) {
                that.center();
			},
            dragend: function (e) {
				CustomKendoWindow.clamp(that.broadcastKendoWindow);
			}
		}).data('kendoWindow');

        this.windowTitleSpan = this.broadcastKendoWindow.wrapper.find('span[class="k-window-title"]');
        this.windowTitleSpan.addClass('rtpAnnouncementTitle');
	}


    buildAudioCallView(idAndNameMap, testerHandStatuses){
        this.testerHandStatuses = testerHandStatuses;

        const muteTemplate = _.template($(widgetTemplate).filter("#broadcastGroupCallTemplate").html());
        this.groupAudioCallDiv.append(muteTemplate)
        const studentsContainer = $('<div>').attr({'id':'groupCallStudentsContainer'});
        this.groupAudioCallDiv.append(studentsContainer);

        this.setupTesterButtonsListeners(idAndNameMap, studentsContainer);
        //click event for proctor mute button
        $('#broadcastAudioCall_muteAudio_proctor').off('click', this.handleProctorMute.bind(this)).on('click', this.handleProctorMute.bind(this));
    
    }

    addGroupAudioWindow(){
        this.groupAudioCallDiv = $('<div>').attr({'id':'groupAudioCallContainer','class':'rtpIcon-no-display video-Div rtp_callVideo_div'});
        var template =  _.template($(widgetTemplate).filter("#toolsTabContainerTemplate").html());
		return template({testerIdentifier: this.testerIdentifier,isBroadcastGroupCall:true});
    }

    createVariables(){
		this.chatBtn = $k('#chatBtn-' + this.testerIdentifier);
		this.endBtn = $k('#toolBarEndBtn_'+ this.testerIdentifier);
		this.groupAudioCallBtn = $k('#groupAudioCallBtn-' + this.testerIdentifier);
    }

    addBroadcastHelpText(){
        let broadcastHelpTextDiv = $('<div>').attr('id','rtp-broadcastHelpTextDiv');
        broadcastHelpTextDiv[0].innerHTML = rtp_i18next.t("proctorWidget:broadcastWidgetHelpText");
        return broadcastHelpTextDiv;
    }

	createBroadcastKendoChat(callback){
		var that = this;
		this.kendoChat = this.broadcastChatDiv.kendoChat({
			sendMessage: function (e) {
                callback(e);
                that.textarea.val("");
				that.textarea.trigger('input');
			},
            post: function (e) {
                //The "Post" event is fired by kendo when messages are sent.  When this happens, "e.text" is just a string.  However, we are also explicitely calling "post" for historical records.
                //When we do this, we are passing an object that contains the chat message and the timestamp as "e.text".  This is done so that we can override the timestamp to use the historical message's timestamp rather than the current time.
                if(typeof e.text === 'object') {
                    e.timestamp = new Date(e.text.timestamp);
                    e.text = e.text.text;
                }
            }
		}).data("kendoChat");
        CustomKendoWindow.replaceInputWithTextarea(this);
	}

    postNotificationMsg(textMsg) {
        this.kendoChat.renderAttachments({
            attachments: [{
                contentType: "notification",
                content: {
                    title: "Notification",
                    text: textMsg,
                    timestamp: new Date()
                }
            }],
            attachmentLayout: "list"
        }, this.kendoChat.getUser());
	}

    addTooltips(){
        this.broadcastKendoWindow.wrapper.find('button[aria-label="Close"]').kendoTooltip({content: rtp_i18next.t("generalWords:close")});
        this.broadcastKendoWindow.wrapper.find('button[aria-label="window-Minimize"]').kendoTooltip({content: rtp_i18next.t("generalWords:minimize") });	
		this.broadcastChatDiv.find('button[aria-label="Send message"]').kendoTooltip({ position: "right", content: rtp_i18next.t("proctorWidget:sendAnnouncement") });
		$k('#broadcastAudioCall_muteAudio_proctor').kendoTooltip({position: "right", content: rtp_i18next.t("generalWords:muteMicrophone")});
        this.switchToChatModeTooltips(false);
    }

    deleteChatAudioCallTooltips(){
		this.chatBtn.data("kendoTooltip").destroy();
		this.groupAudioCallBtn.data("kendoTooltip").destroy();
	}

    center() {
		this.broadcastKendoWindow.options.position.top = ($(window).height() / 2) - (this.broadcastKendoWindow.wrapper.height() / 2);
		this.broadcastKendoWindow.options.position.left = ($(document).width() / 2) - (this.broadcastKendoWindow.wrapper.width() / 2);
        this.broadcastKendoWindow.wrapper.css('left', this.broadcastKendoWindow.options.position.left);
        this.broadcastKendoWindow.wrapper.css('top', this.broadcastKendoWindow.options.position.top);
	}

    setMinimizedWindowPosition(wrapper) {
        wrapper.css({ top: window.innerHeight - wrapper[0].clientHeight - 5, left:$("body").prop("scrollWidth") - wrapper[0].clientWidth});
    }

    preventDblClickAndRightClick() {
		let wrapper = this.broadcastKendoWindow.wrapper;
		wrapper.find('.k-window-titlebar').dblclick(function(e) {
			e.stopImmediatePropagation();
		});

		wrapper.bind("contextmenu", function(e){
			return false;
		});
	}

    handleWindowResize(){
		if(this.broadcastKendoWindow.options.isMinimized){
            this.setMinimizedWindowPosition(this.broadcastKendoWindow.wrapper);
		}else{
			this.center();
        }
    }

    switchToChatModeTooltips(isGroupAudioCallRunning){
        this.chatBtn.kendoTooltip({position: "left" , content: rtp_i18next.t('generalWords:chatModeSelected')});
        let groupCallTooltip = isGroupAudioCallRunning ? rtp_i18next.t('generalWords:groupCall') : rtp_i18next.t('generalWords:startGroupAudioCall');
        this.groupAudioCallBtn.kendoTooltip({position: "right" , content: groupCallTooltip})
    }

    switchToGroupCallTooltips(){
        this.chatBtn.kendoTooltip({position: "left" , content: rtp_i18next.t('generalWords:chat')});
        this.groupAudioCallBtn.kendoTooltip({position: "right" , content: rtp_i18next.t('generalWords:groupCallModeSelected')})
    }

    handleGroupAudioCallStart(){
        this.switchToGroupAudioCall();
        this.showEndButton();
        // Enable button just to make sure proctor can end the call if needed for any reason.
        this.enableEndCallBtn();
        this.deleteChatAudioCallTooltips();
        this.switchToGroupCallTooltips();
        CustomKendoWindow.hideMinimizeButton(this.broadcastKendoWindow);
        CustomKendoWindow.hideCloseButton(this.broadcastKendoWindow)
        CustomKendoWindow.changeVideoLabel( $('#audioCallLabel'),rtp_i18next.t('generalWords:inGroupCall'),true);
        CustomKendoWindow.videoBtnHighlightOff(this.groupAudioCallBtn);
        const studentsContainer = $('<div>').attr({'id':'groupCallStudentsContainer'});
        this.setupTesterButtonsListeners(this.proctorObj.idAndNameMap, studentsContainer);
    }

    setupTesterButtonsListeners(idAndNameMap, studentsContainer){
        const template = _.template($(widgetTemplate).filter("#groupAudioCallProctorView").html());
        for(const [key, value] of idAndNameMap){
            let studentEntry = $(template({testerIdentifier: key, displayName: value.displayName}));
            studentEntry.find(`#groupCallHand_${key}`).off('click',this.handleTesterHand.bind(this, key)).on('click',this.handleTesterHand.bind(this, key));
            studentEntry.find(`#groupCallMuteBtn_${key}`).off('click',this.handleTesterMute.bind(this, key)).on('click',this.handleTesterMute.bind(this, key));
            studentsContainer.append(studentEntry);
            this.setInitialHandStatus(key);
        }
    }

    switchToGroupAudioCall(){
        RTP.UIUtil.hideElement(this.broadcastChatDiv);
        RTP.UIUtil.showElement(this.groupAudioCallDiv);
        RTP.UIUtil.setActiveElement(this.groupAudioCallBtn);
        RTP.UIUtil.setInActiveElement(this.chatBtn)
    }

    setInitialHandStatus(testerIdentifier) {
        if(this.testerHandStatuses.get(testerIdentifier)) {
            this.setHandIconRaised(testerIdentifier);
        }
    }

     setHandIconLowered(testerIdentifier) {
        $(`#groupCallHand_${testerIdentifier}`).addClass('rtp_element_hide');
        if($(`#groupCallMuteAudioIcon_${testerIdentifier}`).hasClass("mutedMicrophoneIcon")){
            $(`#groupCallMuteBtn_${testerIdentifier}`).addClass('rtp_element_hide');
        }
        this.testerHandStatuses.set(testerIdentifier, false);
	}

	setHandIconRaised(testerIdentifier) {
		$(`#groupCallHand_${testerIdentifier}`).removeClass('rtp_element_hide');
		$(`#groupCallMuteBtn_${testerIdentifier}`).removeClass('rtp_element_hide');
        this.testerHandStatuses.set(testerIdentifier, true);
	}

    handleTesterHand(testerIdentifier) {
        if(this.testerHandStatuses.get(testerIdentifier)) {
            $(document).trigger('lowerTesterHand', [testerIdentifier]);
        }
    }

    toggleTesterMuteButton(isMuted, testerIdentifier) {
        let icon = $(`#groupCallMuteAudioIcon_${testerIdentifier}`);
        this.testerMuteStatuses.set(testerIdentifier, isMuted);
        CustomKendoWindow.updateMuteIcon(icon, isMuted);
        if(isMuted && $(`#groupCallHand_${testerIdentifier}`).hasClass("rtp_element_hide")){
            $(`#groupCallMuteBtn_${testerIdentifier}`).addClass('rtp_element_hide');
        }
    }

    handleTesterMute(testerIdentifier) {
        //get the current mute status and reverse it
        let shouldMute = !(this.testerMuteStatuses.get(testerIdentifier) ?? true);
        $(document).trigger('toggleTesterMute', [testerIdentifier, shouldMute]);
    }

    handleProctorMute() {
        this.isProctorMuted = !this.isProctorMuted;
        $(document).trigger('toggleProctorMute', [this.isProctorMuted]);

        const icon = $('#broadcastAudioCall_muteAudioIcon_proctor');
        CustomKendoWindow.updateMuteIcon(icon, this.isProctorMuted);

        const muteButton = $('#broadcastAudioCall_muteAudio_proctor');
        muteButton.data("kendoTooltip")?.destroy();

        const micTooltip = rtp_i18next.t(this.isProctorMuted ? "generalWords:unMuteMicrophone" : "generalWords:muteMicrophone");
        muteButton.kendoTooltip && muteButton.kendoTooltip({ position: "right", content: micTooltip });
    }

    attendeeJoined(data){
        var testerId = data.studentId;
        $('#groupCallStatus_'+testerId + '> svg')[0].classList.add('fa-phone' ,'rtp_groupCall_InCall_Icon')
        $('#groupCallStatus_'+testerId + '> svg')[0].classList.remove('fa-spinner','rtp_groupCall_Connecting_Icon')
        this.handleAttendeeJoinedCount();
        //keep track of attendees in call
        this.attendeesInCall.add(testerId);
    }

    handleEndGroupCall(){
        CustomKendoWindow.changeVideoLabel( $('#audioCallLabel'),rtp_i18next.t('generalWords:groupCall'),false)
        this.switchToBroadcastChat();
        this.hideEndButton();
        this.disableEndCallBtn();
        this.resetStudentStatus();
        this.resetStudentStatusCount();
        this.deleteChatAudioCallTooltips();
        this.switchToChatModeTooltips(false);
        CustomKendoWindow.restoreMinimizeButton(this.broadcastKendoWindow);
        CustomKendoWindow.restoreHideButton(this.broadcastKendoWindow);
        CustomKendoWindow.updateMuteIcon($('#broadcastAudioCall_muteAudioIcon_proctor'), false);
    }

    switchToBroadcastChat(isGroupAudioCallRunning){
        RTP.UIUtil.hideElement(this.groupAudioCallDiv);
        RTP.UIUtil.showElement(this.broadcastChatDiv);
        RTP.UIUtil.setActiveElement(this.chatBtn);
        RTP.UIUtil.setInActiveElement(this.groupAudioCallBtn)
        this.deleteChatAudioCallTooltips();
        this.switchToChatModeTooltips(isGroupAudioCallRunning);
        if(isGroupAudioCallRunning){
            CustomKendoWindow.videoBtnHighlightOn(this.groupAudioCallBtn);
		} else {
			CustomKendoWindow.videoBtnHighlightOff(this.groupAudioCallBtn);
        }
    }

    resetStudentStatus(){
        const groupCallStatus = $('.rtp_studentStatusIcon > svg');
        [...groupCallStatus].map(element => {
            $(element)[0].classList.remove('fa-phone', 'rtp_groupCall_InCall_Icon','fa-phone-slash','rtp_groupCall_missed_Icon')
            $(element)[0].classList.add('fa-spinner','rtp_groupCall_Connecting_Icon');
        })
    }

    resetStudentStatusCount(){
        $('#rtp_groupCall_missedCall_count')[0].innerText = 0;
        $('#rtp_groupCall_inCall_count')[0].innerText = 0;
    }

    missedGroupCallStudentsUI(students){
        students.keys().forEach(testerIdentifier => {
            var studentRow = $('#groupCallStatus_'+testerIdentifier+'> .rtp_groupCall_Connecting_Icon');
            if(studentRow.length > 0){
                this.increaseMissedCallCount();
                this.changeToMissedCallIcon(testerIdentifier);
            }
        })
    }

    increaseMissedCallCount(){
        $('#rtp_groupCall_missedCall_count')[0].innerText =  Number($('#rtp_groupCall_missedCall_count')[0].innerText)  + 1
    }

    handleAttendeeJoinedCount(flag){
        if(flag == "missed"){
            $('#rtp_groupCall_inCall_count')[0].innerText =  Number($('#rtp_groupCall_inCall_count')[0].innerText)  - 1;
            this.increaseMissedCallCount();
        }else{
            $('#rtp_groupCall_inCall_count')[0].innerText =  Number($('#rtp_groupCall_inCall_count')[0].innerText)  + 1
        }
    }

    changeToMissedCallIcon(student){
        $('#groupCallStatus_'+student+'> svg')[0].classList.add('fa-phone-slash','rtp_groupCall_missed_Icon');
        $('#groupCallStatus_'+student+'> svg')[0].classList.remove('fa-spinner','rtp_groupCall_Connecting_Icon','fa-phone', 'rtp_groupCall_InCall_Icon');
    }

    handleStudentDroppedGroupCall(student){
        this.handleAttendeeJoinedCount("missed");
        this.changeToMissedCallIcon(student);
    }

    setEndCallBtn(){
        $(`#toolBarEndBtn_${this.testerIdentifier}`).removeClass('endBtn');
		$(`#toolBarEndBtn_${this.testerIdentifier}`).addClass('endCallBtn');
        $(`#toolBarEndBtn_${this.testerIdentifier}`)[0].innerHTML = rtp_i18next.t("proctorWidget:endCall");
        this.disableEndCallBtn();
    }

    disableEndCallBtn(){
        $(`#toolBarEndBtn_${this.testerIdentifier}`).prop('disabled', true);
    }

    disableGroupCallBtn(){
        $(`#groupAudioCallBtn-${this.testerIdentifier}`).prop('disabled', true);
    }

    enableGroupCallBtn(){
        $(`#groupAudioCallBtn-${this.testerIdentifier}`).prop('disabled', false);
    }

    enableEndCallBtn() {
        $(`#toolBarEndBtn_${this.testerIdentifier}`).prop('disabled', false);
    }

    hideEndButton(){
        RTP.UIUtil.hideElement($(`#toolBarEndBtn_${this.testerIdentifier}`));
    }
    showEndButton(){
        RTP.UIUtil.showElement($(`#toolBarEndBtn_${this.testerIdentifier}`));
    }

    cleanupController(){
        this.broadcastKendoWindow.destroy();
        this.attendeesInCall.clear();
    }

    // Programmatic close
    closeBroadcastWindow() {
        // Prefer close() to trigger kendo events; fall back to destroy if needed
        if (this.broadcastKendoWindow?.close) {
            this.broadcastKendoWindow.close();
        }else if(this.broadcastKendoWindow?.destroy){
            this.broadcastKendoWindow.destroy();
        }
    }
}
